import { BfiApi, IApiResponse } from './bfiApi';
import { ISearchCriteria } from './common';

export interface IHmdaFieldUpdate {
    id: number;
    fieldId: number;
    value?: string | null;
}

export interface IHmdaExportCriteria {
    bfiNumber?: string | null;
    types: [number];
    applyStartDate?: string | null;
    applyEndDate?: string | null;
    actionTakenStartDate?: string | null;
    actionTakenEndDate?: string | null;
    street?: string | null;
    city?: string | null;
    state?: string | null;
    county?: string | null;
    zip?: string | null;
    showOnlyRowsWithAlerts: boolean;
}

export interface IHmdaExportFilingInformation {
    id: number;
    recordIdentifier: number;
    financialInstitutionName?: string | null;
    calendarYear: number;
    calendarQuarter: number;
    contactName?: string | null;
    contactPhoneNumber?: string | null;
    contactEmail?: string | null;
    contactStreet?: string | null;
    contactCity?: string | null;
    contactState?: string | null;
    contactZipCode?: string | null;
    filingAgencyId: number;
    federalTaxpayerIdentificationNumber?: string | null;
    legalIdentifier?: string | null;
}

export class HmdaApi extends BfiApi {
    getFields(): Promise<IApiResponse> {
        return super.get('/hmda/fields');
    }
    getData(criteria: ISearchCriteria): Promise<IApiResponse> {
        return super.post('/hmda/data', criteria);
    }
    setData(update: IHmdaFieldUpdate): Promise<IApiResponse> {
        return super.post('/hmda/data/update', update);
    }
    deleteData(ids: [number]): Promise<IApiResponse> {
        return super.post('/hmda/data/delete', ids);
    }
    exportGridAsExcel(criteria: IHmdaExportCriteria): Promise<IApiResponse> {
        return super.post('/hmda/data/export/excel', criteria, {
            responseType: 'blob',
        });
    }
    exportGridAsExcelTransposed(criteria: IHmdaExportCriteria): Promise<IApiResponse> {
        return super.post('/hmda/data/export/exceltransposed', criteria, {
            responseType: 'blob',
        });
    }
    exportGridAsText(criteria: IHmdaExportCriteria): Promise<IApiResponse> {
        return super.post('/hmda/data/export/pipedelimited', criteria, {
            responseType: 'blob',
        });
    }
    getAvailableFilingYears(): Promise<IApiResponse> {
        return super.get('/hmda/data/export/filinginfo/availablefilingyears');
    }
    getExportFilingInformation(): Promise<IApiResponse> {
        return super.get('/hmda/data/export/filinginfo/get');
    }
    setExportFilingInformation(filingInformation: IHmdaExportFilingInformation): Promise<IApiResponse> {
        return super.post('/hmda/data/export/filinginfo/update', filingInformation);
    }
    getManageableDeletedHMDARecords(criteria: ISearchCriteria): Promise<IApiResponse> {
        return super.post('/hmda/data/managemanuallydeleted', criteria);
    }
    restoreManuallyDeletedHMDARecord(id: number): Promise<IApiResponse> {
        return super.post('/hmda/data/restoremanuallydeleted', id);
    }
    requeueAllAsApp(): Promise<IApiResponse> {
        return super.post('/hmda/data/requeue/apps');
    }
    requeueAllAsLoan(): Promise<IApiResponse> {
        return super.post('/hmda/data/requeue/loans');
    }
}
